import React from 'react'
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import ContractorNotDivided from "./ContractorNotDivided";
import ContractorDivided from "./ContractorDivided";


function ContractorData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const partialOffers = gVal("form.orderObject.partialOffers", false)

    return (<>

        <Collapse in={partialOffers === false} unmountOnExit>
            <ContractorNotDivided id={gId("notDivided")} formikProps={formikProps} />
        </Collapse>

        <Collapse in={partialOffers === true} unmountOnExit>
            <ContractorDivided id={id} formikProps={formikProps}/>
        </Collapse>

    </>)
}

ContractorData.propTypes = {};

export default ContractorData;
